module.exports = __webpack_public_path__ + "static/Optiplex5-986e6af10391b830c6564b8772fac675.png";